import { QueryClient } from 'react-query/core';
import { onError } from './HandleError';

export function getTotalPage(headers) {
   return Math.ceil(headers['x-total'] / headers['x-per-page']);
}
export const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         cacheTime: 10000,
         onError: (error) => onError(error),
         retry: 0,
      },
      mutations: {
         onError: (error) => onError(error),
         retry: 0,
      },
   },
});

export const getNextPageParam = (headers) => {
   const page = Number(headers['x-page']);
   const totalPage = Number(getTotalPage(headers));

   return page < totalPage ? page + 1 : false;
};
